import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from 'styled-components';
import { useTranslation } from '@yoweb/next-i18next';
import { media } from '@yoweb/ui/styles/utils';
import { Grid } from '@yoweb/ui/components/Grid';
import { Textarea } from '@yoweb/ui/components/form';
import { Title } from '@yoweb/ui/components/typography/Title';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { ActionModalFooter } from '@poplar/components/ActionModal/ActionModalFooter';
import { STANDARD_INPUT_MAX_LENGTH } from '@poplar/constants/app';
import { FlyoutContent, FlyoutContentContainer, StepHeader, StepGrid } from './Common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AdditionalFeedbackStep = function AdditionalFeedbackStep(_ref) {
  var taskFeedback = _ref.taskFeedback,
      isSubmitting = _ref.isSubmitting,
      onNext = _ref.onNext;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(FlyoutContentContainer, {
    "data-testid": "additional-feedback-step",
    children: [/*#__PURE__*/_jsx(FlyoutContent, {
      children: /*#__PURE__*/_jsxs(StepGrid, {
        children: [/*#__PURE__*/_jsx(StepHeader, {
          taskFeedback: taskFeedback
        }), /*#__PURE__*/_jsxs(Grid, {
          gap: "normal3",
          children: [/*#__PURE__*/_jsx(Grid, {
            justifyItems: "left",
            children: /*#__PURE__*/_jsx(StepTitle, {
              size: "sm",
              as: "h3",
              textAlign: "left",
              children: t('todo-feedback.additional-feedback-title')
            })
          }), /*#__PURE__*/_jsx(Textarea, {
            id: "detailFeedbackText",
            name: "detailFeedbackText",
            label: t('todo-feedback.additional-feedback-placeholder'),
            "data-testid": "additional-feedback-input",
            maxLength: STANDARD_INPUT_MAX_LENGTH,
            maxHeight: 300,
            rows: 1
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(ActionModalFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        size: "lg",
        type: "submit",
        isLoading: isSubmitting,
        "data-testid": "additional-feedback-submit-button",
        onClick: onNext,
        isFullWidth: true,
        children: t('actions.submit', {
          ns: 'common'
        })
      })
    })]
  });
};
var StepTitle = styled(Title).withConfig({
  componentId: "sc-d1yjh0-0"
})(["&&{", "}"], media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      max-width: 100%;    \n    "]))));